export const DEFAULT_REGION_ID = 1; // HONG KONG ID
